import { OnInit, AfterViewInit, OnDestroy, QueryList } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { TimelineDatePipe } from "@app/pipes/timeline-date.pipe";
import { DatePipe } from "@app/pipes/date.pipe";
import { localDateFromPhpDateField, TimePipe } from "@app/pipes/time.pipe";
var CsAgGridCustomCellRendererComponent = /** @class */ (function () {
    function CsAgGridCustomCellRendererComponent(timelineDateTime, shortDate, timePipe, sanitizer) {
        this.timelineDateTime = timelineDateTime;
        this.shortDate = shortDate;
        this.timePipe = timePipe;
        this.sanitizer = sanitizer;
        this.cellRenderData = [];
        this.showFullText = false;
        this.sanitizedHtmlCache = new Map();
        this.scrollListener = null;
    }
    CsAgGridCustomCellRendererComponent.prototype.ngOnInit = function () {
        var _a;
        if (!this.params) {
            return;
        }
        if (this.params.data) {
            this.cellRenderData = this.params.data;
        }
        else if (this.params.node && this.params.node.group && this.params.value != null) {
            // Group row: no row data — build minimal object so keyMapping text fields can display
            var keyMapping = (this.params.cellRendererParams && this.params.cellRendererParams.keyMapping) ||
                this.params.keyMapping;
            if (keyMapping && keyMapping.length) {
                var first = keyMapping[0];
                if (first && first.text) {
                    this.cellRenderData = (_a = {}, _a[first.text] = this.params.value, _a);
                }
            }
        }
    };
    CsAgGridCustomCellRendererComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var api = this.params && this.params.api;
        if (api && typeof api.addEventListener === 'function') {
            this.scrollListener = function () { return _this.hideTooltips(); };
            api.addEventListener('bodyScroll', this.scrollListener);
        }
    };
    CsAgGridCustomCellRendererComponent.prototype.ngOnDestroy = function () {
        if (this.scrollListener && this.params && this.params.api && typeof this.params.api.removeEventListener === 'function') {
            this.params.api.removeEventListener('bodyScroll', this.scrollListener);
            this.scrollListener = null;
        }
    };
    CsAgGridCustomCellRendererComponent.prototype.hideTooltips = function () {
        if (this.tooltips) {
            this.tooltips.forEach(function (t) { return t.hide(); });
        }
    };
    CsAgGridCustomCellRendererComponent.prototype.hasContent = function (key, cellRenderData) {
        return !!(key.profileImage ||
            (key.type === 'custom_icon' && key.iconsList[cellRenderData[key.iconKey]]) ||
            (key.type === 'static_icon' && key.iconName) ||
            (key.text && this.getTextValue(key, cellRenderData)) ||
            (key.customText && key.customTextList[cellRenderData[key.customTextKey]]));
    };
    /** Value for key.text; fallback to 'name' when key.text is 'File name' (files grid). Returns raw value (HTML or plain text). */
    CsAgGridCustomCellRendererComponent.prototype.getTextValue = function (key, cellRenderData) {
        if (!key || !key.text || !cellRenderData)
            return null;
        var val = cellRenderData[key.text];
        var toTitleCase = function (str) {
            return str
                .toLowerCase()
                .split(' ')
                .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                .join(' ');
        };
        if (key.text === 'status') {
            var statusValue = typeof val === 'string' ? toTitleCase(val) : toTitleCase(String(val));
            return statusValue.replace(/_/g, ' ');
        }
        if (val != null && val !== '')
            return typeof val === 'string' ? val : String(val);
        if (key.text === 'File name' && cellRenderData['name'] != null && cellRenderData['name'] !== '') {
            var name_1 = cellRenderData['name'];
            return typeof name_1 === 'string' ? name_1 : String(name_1);
        }
        return null;
    };
    /** Sanitize HTML for key.text when key.renderTextAsHtml is true. Cached so the same input always returns the same SafeHtml instance. */
    CsAgGridCustomCellRendererComponent.prototype.getSanitizedTextValue = function (key, cellRenderData) {
        var val = this.getTextValue(key, cellRenderData);
        if (val == null || val === '' || !key || !key.renderTextAsHtml)
            return null;
        return this.getCachedSafeHtml(val);
    };
    /** Plain text for tooltip when value may contain HTML (strip tags). */
    CsAgGridCustomCellRendererComponent.prototype.getTextValuePlain = function (key, cellRenderData) {
        var val = this.getTextValue(key, cellRenderData);
        if (val == null || val === '')
            return null;
        if (key && key.renderTextAsHtml && /<[^>]+>/.test(val)) {
            return val.replace(/<[^>]*>/g, '').trim() || val;
        }
        return val;
    };
    /** Sanitize HTML for additionalText when key.renderAdditionalTextAsHtml is true. Cached so the same input always returns the same SafeHtml instance. */
    CsAgGridCustomCellRendererComponent.prototype.getSanitizedAdditionalText = function (value, key) {
        if (value == null || value === '' || !key || !key.renderAdditionalTextAsHtml)
            return null;
        var str = typeof value === 'string' ? value : String(value);
        return this.getCachedSafeHtml(str);
    };
    /** Returns the same SafeHtml instance for a previously-seen string, avoiding a new object on every change-detection check. */
    CsAgGridCustomCellRendererComponent.prototype.getCachedSafeHtml = function (val) {
        var safeHtml = this.sanitizedHtmlCache.get(val);
        if (!safeHtml) {
            safeHtml = this.sanitizer.bypassSecurityTrustHtml(val);
            this.sanitizedHtmlCache.set(val, safeHtml);
        }
        return safeHtml;
    };
    /** Whether Angular tooltip is enabled for this cell (cellRendererParams.tooltip !== false). */
    CsAgGridCustomCellRendererComponent.prototype.isTooltipEnabled = function () {
        var p = this.params && this.params.cellRendererParams;
        return p ? p.tooltip !== false : true;
    };
    CsAgGridCustomCellRendererComponent.prototype.refresh = function (params) {
        throw new Error("Method not implemented.");
    };
    CsAgGridCustomCellRendererComponent.prototype.isDateObject = function (value) {
        return value && typeof value === 'object' && 'date' in value;
    };
    CsAgGridCustomCellRendererComponent.prototype.getUserDate = function (val) {
        var forPipes;
        if (val && typeof val === 'object' && 'date' in val) {
            var d = localDateFromPhpDateField(val.date);
            if (!d) {
                return '';
            }
            forPipes = d;
        }
        else {
            forPipes = val;
        }
        var shortdate = this.shortDate.transform(forPipes);
        var usertime = this.timePipe.transform(forPipes);
        return shortdate + ' (' + usertime + ')';
    };
    CsAgGridCustomCellRendererComponent.prototype.getIconClass = function (iconValue) {
        if (typeof iconValue === 'number' || !isNaN(Number(iconValue))) {
            var id = typeof iconValue === 'number' ? iconValue : parseInt(iconValue, 10);
            if (id == 4 || id == 5) {
                return 'ios.svg';
            }
            return this.getIconById(id);
        }
        else { // return as-is if it's already a string (class name)
            if (iconValue == 'fa fa-apple') {
                return 'ios.svg';
            }
            else {
                return iconValue;
            }
        }
    };
    CsAgGridCustomCellRendererComponent.prototype.getIconById = function (id) {
        var createdByTypes = this.getCreatedbyType();
        if (isNaN(id)) {
            return '';
        }
        var foundType = createdByTypes.find(function (item) { return item.id === id.toString(); });
        return foundType ? foundType.icon : 'fa-regular fa-cloud';
    };
    CsAgGridCustomCellRendererComponent.prototype.getCreatedbyType = function () {
        return [
            { id: '1', text: 'System', icon: 'fa-sharp fa-regular fa-globe' },
            { id: '2', text: 'Online', icon: 'fa-sharp fa-regular fa-globe' },
            { id: '3', text: 'Webservice', icon: 'fa-sharp fa-regular fa-globe' },
            { id: '4', text: 'iPhone', icon: 'fa fa-apple' },
            { id: '5', text: 'iPad', icon: 'fa fa-apple' },
            { id: '6', text: 'Android tablet', icon: 'fa fa-brands fa-android' },
            { id: '8', text: 'Android phone', icon: 'fa fa-brands fa-android' },
        ];
    };
    CsAgGridCustomCellRendererComponent.prototype.getCustomIconColor = function (key, cellRenderData) {
        if (!key || key.type !== 'custom_icon' || !key.iconsList || !cellRenderData) {
            return '';
        }
        var iconKey = cellRenderData[key.iconKey];
        var iconData = key.iconsList[iconKey];
        return iconData && iconData.color ? iconData.color : '';
    };
    return CsAgGridCustomCellRendererComponent;
}());
export { CsAgGridCustomCellRendererComponent };
